import React from "react"
import { EventItem } from "Components"

export class EventCalendarList extends React.Component {
  render() {
    const { track, full, featured, big, countdown, node } = this.props

    // let eventURL
    let eventURL = node.webinarlink ? node.webinarlink : node.eventsite ? node.eventsite : ""

    // console.log("EVENT: ", node.events)
    // console.log("eventURL: ", node.eventsite)
    // if (node.eventsite && /www/.test(node.eventsite)) {
    // if (/www/.test(node.eventsite)) {
    //   eventURL = node.eventsite
    //     .toString()
    //     .replace(/\s+/g, "")
    //     .replace(/https:\/\/www.cxosync.com+/g, "")
    // }

    let eventStartTime = node.time ? node.time.split(" - ")[0] : ""
    let eventEndTime = node.time ? node.time.split(" - ")[1] : ""

    return (
      <EventItem
        banner={node.childrenFile[0] != null ? node.childrenFile[0].childImageSharp.fluid : ""}
        big={big}
        brandName={node.brand}
        countdown={countdown}
        eventDate={node.date}
        eventCity={node.city}
        eventEnd={eventEndTime}
        eventEndDate={node.date}
        eventId={node.id}
        eventName={node.events}
        eventRegion={node.regionName}
        eventSponsors={node ? node.companies : ""}
        eventStart={eventStartTime}
        eventState={node.state}
        eventType={node.eventType}
        eventTime={node.eventTime}
        eventPanel={node.panel}
        featured={featured}
        full={full}
        rating={3}
        track={track}
        eventURL={eventURL}
        className={this.props.className}
        attend={this.props.attend || "*missing*"}
        share={this.props.share || "*missing*"}
        sponsor={this.props.sponsor || "*missing*"}
      />
    )
  }
}

export default EventCalendarList
